export default __webpack_public_path__ + "static/media/view-claimed-item.f674a201.png";